<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1.5">
      <InfuseRadioButton
        v-model="radioValue"
        class="pb-0.5"
        value="is"
        group-name="radio-gaga"
        :label="t(tRegular())"
      />
      <slot v-if="!negated" />
    </div>

    <div class="flex flex-col gap-1.5">
      <InfuseRadioButton
        v-model="radioValue"
        class="pb-0.5"
        value="isNot"
        group-name="radio-gaga"
        :label="t(tNegated())"
      />
      <slot v-if="negated" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ComparisonType } from '@infuse/ui/domain';
import { computed, Ref, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { InfuseRadioButton } from '../../index';

const { t } = useI18n();

interface Props {
  modelValue: boolean;
  comparisonType?: ComparisonType;
}

const props = withDefaults(defineProps<Props>(), {
  comparisonType: ComparisonType.EQ
});

interface Emits {
  (e: 'update:modelValue', negated: boolean): void;
}

const emit = defineEmits<Emits>();

const radioValue: Ref<string> = ref('is');

const negated = computed(() => radioValue.value === 'isNot');

watch(radioValue, (_) => emit('update:modelValue', negated.value), { immediate: true });

const tRegular = (): string => {
  const base = 'ui.filter.negatable.';
  if (props.comparisonType === ComparisonType.EQ) {
    return base + 'is';
  } else if (props.comparisonType === ComparisonType.NE) {
    return base + 'isNot';
  } else if (props.comparisonType === ComparisonType.LT) {
    return base + 'lessThan';
  } else if (props.comparisonType === ComparisonType.LTE) {
    return base + 'lessThanOrEqual';
  } else if (props.comparisonType === ComparisonType.GT) {
    return base + 'greaterThan';
  } else if (props.comparisonType === ComparisonType.GTE || props.comparisonType === ComparisonType.GT) {
    return base + 'greaterThanOrEqual';
  } else {
    return base + 'is';
  }
};

const tNegated = () => {
  const base = 'ui.filter.negatable.';
  if (props.comparisonType === ComparisonType.EQ) {
    return base + 'isNot';
  } else if (props.comparisonType === ComparisonType.NE) {
    return base + 'is';
  } else if (props.comparisonType === ComparisonType.LT) {
    return base + 'greaterThanOrEqual';
  } else if (props.comparisonType === ComparisonType.LTE) {
    return base + 'greaterThan';
  } else if (props.comparisonType === ComparisonType.GT) {
    return base + 'lessThanOrEqual';
  } else if (props.comparisonType === ComparisonType.GTE) {
    return base + 'lessThan';
  } else {
    return base + 'isNot';
  }
};
</script>

